import {
  Control,
  FieldValues,
  Path,
  useController
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import styles from "./InscriptionDroitImage.module.scss";

type Props<FormSchemaType extends FieldValues> = {
  control: Control<any>;

  checkboxInputName: Path<FormSchemaType>;
};
export default function InscriptionDroitImage<
  FormSchemaType extends FieldValues
>(props: Props<FormSchemaType>) {
  const { t } = useTranslation();
  const { control, checkboxInputName } = props;

  const { field, formState } = useController<FormSchemaType>({
    name: checkboxInputName,
    control,
  });
  const formErrors = formState.errors;
  const errorName = formErrors?.[checkboxInputName];

  return (
    <article className={styles.inscriptionDroitImage}>
      <header className={styles.inscriptionDroitImage__header}>
        <h2>{t("inscriptionDroitImage.title")}</h2>
      </header>
      <main className={styles.inscriptionDroitImage__main}>
        <section className={styles.inscriptionDroitImage__main__text}>
          <p>{t("inscriptionDroitImage.description1")}</p>
          <p>{t("inscriptionDroitImage.description2")}</p>
        </section>
        <section className={styles.inscriptionDroitImage__main__inputs}>
          <div>
            <input
              id="droitImage_inscirption_radio_button_true"
              type="radio"
              {...field}
              value="true"
              defaultChecked={field.value === "true"} // Set defaultChecked based on field value
            />
            <label htmlFor="droitImage_inscirption_radio_button_true">
              {t("common.yes")}
            </label>
          </div>
          <div>
            <input
              id="droitImage_inscirption_radio_button_false"
              type="radio"
              {...field}
              value="false"
              defaultChecked={field.value === "false"} // Set defaultChecked based on field value
            />
            <label htmlFor="droitImage_inscirption_radio_button_false">
              {t("common.no")}
            </label>
          </div>
        </section>
        <label
          className={styles.inscriptionDroitImage__main__errorLabel}
          htmlFor={"droitImage_inscirption_radio_button_false"}
        >
          {/* {formErrors?.[checkboxInputName]?.message?.toString()} */}
          {typeof formErrors?.[checkboxInputName]?.message === "string"
            ? formErrors?.[checkboxInputName]?.message
            : typeof formErrors?.[checkboxInputName]?.message === "object" &&
              formErrors?.[checkboxInputName]?.message !== null &&
              typeof formErrors?.[checkboxInputName]?.message.toString === "function"
              ? formErrors?.[checkboxInputName]?.message.toString()
              : ""}
        </label>
      </main>
    </article>
  );
}
